const appNames = ['trade-ma','trade-contract','intl-gangesweb'];

class I18N {
  constructor(config = {namespace: ''}) {
    const {namespace } = config;
    this.namePrefix = namespace ? `${namespace}.` : '';
  }

  loadI18n() {
    this.resources = window['_I18N_'] || {};
    const elI18ns = document.querySelectorAll('script[type="json/i18n"]');
    for (let i = 0; i < elI18ns.length; i++) {
      try {
        Object.assign(this.resources, JSON.parse(elI18ns[i].innerHTML));
      } catch (e) {
        console.error(e);
      }
    }
  }

  createI18N(config) {
    return new I18N({namespace: config.namespace });
  }

  get(key, data) {
    if (!this.resources) {
      this.loadI18n();
    }
    // 对后端吐出的内容是否含命名空间做兼容, 如果window.mcmsWithoutAppName为true, 则去掉应用前缀
    const trunks = this.namePrefix.split('.');
    const namespace = trunks && trunks[0];
    let i18nKey = `${this.namePrefix}${key}`;
    if (appNames.indexOf(namespace) >= 0 && window.mcmsWithoutAppName) {
      let ret = [];
      for(let i = 1 ;i<trunks.length; i++) {
        ret.push(trunks[i]);
      }
      const newNamePrefix = ret.join('.');
      i18nKey = `${newNamePrefix}${key}`;
    }
    let value = this.resources[i18nKey];
    if (data && typeof data === 'object') {
      for (const key in data) {
        value = value.replace(`{${key}}`, data[key]);
      }
      return value;
    } else {
      return value;
    }
  }

  getLocale() {
    return 'en-us';
  }

  setConfig() {
    // [TODO]
  }
}

const i18n = new I18N();
const createI18N = i18n.createI18N;

export {createI18N};
export default i18n;
